import { httpClient, getAuthHeader } from './../httpClient';

/**
 * Auth headers for react-s3-uploader's signing request. The uploader performs
 * its own XHR (not via httpClient), so the JWT must be passed explicitly. Used
 * by the private upload variants whose signing endpoints require auth.
 * @returns {Object} e.g. { Authorization: 'JWT ...' } or {}
 */
export const getUploadSigningHeaders = () => {
  const auth = getAuthHeader();
  return auth && auth.headers ? auth.headers : {};
};

/**
 * Resolve a short-lived presigned GET URL for a private-bucket object key.
 * @param {string} key - the stored object key (e.g. "tasks/123-abc.png")
 * @param {Object} [opts]
 * @param {boolean} [opts.download] - force a download (Content-Disposition: attachment)
 * @returns {Promise<string|null>}
 */
export const getPrivateDownloadUrl = (key, { download = false } = {}) => {
  if (!key) return Promise.resolve(null);
  return httpClient
    .get('/s3/private/download', { params: { key, ...(download && { download: 1 }) } })
    .then(response => (response && response.data ? response.data.url : null))
    .catch(error => {
      console.log('getPrivateDownloadUrl error', error && error.response);
      return null;
    });
};

/**
 * Resolve presigned GET URLs for multiple private-bucket keys at once.
 * @param {string[]} keys
 * @returns {Promise<Array<{ key: string, url: string }>>}
 */
export const getPrivateDownloadUrls = keys => {
  if (!Array.isArray(keys) || keys.length === 0) return Promise.resolve([]);
  return httpClient
    .post('/s3/private/download-batch', { keys })
    .then(response => (response && response.data ? response.data : []))
    .catch(error => {
      console.log('getPrivateDownloadUrls error', error && error.response);
      return [];
    });
};
